import { createAction } from '@ngrx/store';

export const portalQueryFailureAction = createAction(
  '[Portal API] Query Failure',
  (error: any) => ({ error }),
);

export const portalQuerySuccessAction = createAction('[Portal API] Query Success');
